export const API_BASE_URL = process.env.NODE_ENV === 'production' 
   ? 'https://montecristoapp.rmgsistemas.com'  // Ajusta esta ruta
   : 'http://localhost:3001';